import styled, { css } from "../../__compat__/styled-components/main.entry.mjs.mjs";
export const StyledPopoverLiteContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledPopoverLiteContainer", componentId: "auir-611444a-130fym5" }) `
  position: relative;
`;
const popoverLitePadding = 16;
export const StyledPopoverLite = styled.div.withConfig({ displayName: "auir-611444a-StyledPopoverLite", componentId: "auir-611444a-xtnb31" }) `
  position: absolute;
  z-index: 100000;
  padding: var(${(props) => props.theme.responsive.spacing.m});
  background-color: var(${(props) => props.theme.colors.background.level[2]});
  filter: var(${(props) => props.theme.shadow.background.level[2]});
  will-change: filter;
  width: calc(
    100vw - ${2 * popoverLitePadding}px - 2 *
      var(${(props) => props.theme.responsive.spacing.pageMargin})
  );
  opacity: ${(props) => (props.open ? '1' : '0')};
  visibility: ${(props) => (props.open ? 'visible' : 'hidden')};
  top: ${(props) => (props.open ? 'calc(100% + 20px)' : 'calc(100% - 10px)')};
  transition-timing-function: var(${(props) => props.theme.easing});
  transition-duration: 0.125s;
  transition-property: opacity, visibility, top;
  @media (min-width: ${({ theme }) => theme.breakpoints.l}px) {
    width: max-content;
  }
`;
export const StyledTriggerContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledTriggerContainer", componentId: "auir-611444a-1r54hsv" }) `
  display: inline-flex;
  position: relative;

  // Add this to show the tip when using icon button
  .popoverlite-trigger {
    overflow: visible;
  }

  ${(props) => props.withTip &&
    css `
      ::before {
        z-index: 100001;
        left: 50%;
        transform: translateX(-10px);
        content: '';
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        filter: drop-shadow(0px -3px 2px rgba(0, 0, 0, 0.1));
        border-bottom: 10px solid var(${props.theme.colors.background.level[2]});
        transition-property: opacity, visibility, bottom;
        transition-timing-function: var(${props.theme.easing});
        transition-duration: 0.125s;
        visibility: ${props.open ? 'visible' : 'hidden'};
        opacity: ${props.open ? '1' : '0'};
        bottom: ${props.open ? '-20px' : '10px'};
      }
    `}
`;
//# sourceMappingURL=PopoverLite.styles.mjs.mjs.map